export const REPORT = {
  GET_REPORT: 'REPORT_GET',
  GET_REPORT_SUCCESS: 'REPORT_GET_REPORT_SUCCESS',
  GET_REPORT_FAILURE: 'REPORT_GET_REPORT_FAILURE',

  GENERATE: 'REPORT_GENERATE',
  GENERATE_SUCCESS: 'REPORT_GENERATE_SUCCESS',
  GENERATE_FAILURE: 'REPORT_GENERATE_FAILURE',
}
